import React from "react";

const DeleteModal = ({ show, onClose, onConfirm, rowToDelete = null }) => {
  if (!show) return null; // Don't render if modal is hidden

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md flex justify-center items-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 w-full max-w-md mx-auto rounded shadow-lg overflow-hidden p-4">
        <p className="text-gray-800 dark:text-gray-200 text-center text-lg md:text-base">
          Are you sure you want to delete the selected items?
        </p>
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="bg-gray-300 dark:bg-gray-600 dark:text-gray-200 px-4 py-2 rounded mr-2 text-sm md:text-base hover:bg-gray-400 dark:hover:bg-gray-700 transition duration-300"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(rowToDelete)}
            className="bg-red-500 text-white px-4 py-2 rounded text-sm md:text-base hover:bg-red-600 transition duration-300"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;